import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { logout } from '@state/auth/auth.actions';
import { selectAuthState } from '@state/auth/auth.selectors';
import { AppState } from '@state/index';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean {
    if (isPlatformServer(this.platformId)) {
      return true;
    }

    return this.store.select(selectAuthState).pipe(
      map(auth => {
        // Sessão temporária do antigo login de banco por link (removido no Kit Banco): não entra na plataforma.
        if (auth.isTemporary) {
          this.store.dispatch(logout());
          return this.router.createUrlTree(['/auth/login']);
        }
        const now = new Date();
        if (!auth.expiresAt) {
          this.isntAuthenticated(state);
        } else {
          const isAuthenticated = auth.token && auth.expiresAt >= now;

          if (!isAuthenticated) {
            this.isntAuthenticated(state);
          }
          return true;
        }
        return true;
      })
    );
  }

  isntAuthenticated(state: RouterStateSnapshot) {
    if (state.url !== '/' && state.url !== '') {
      this.router.navigate(['/auth/login'], {
        queryParams: { returnUrl: state.url },
      });
    } else {
      this.router.navigate(['/auth/login']);
    }
    return false;
  }
}
